export const collection = () => ({
    metadata: `/collections`,
    totalListings: `/listings/total`,
    totalSales: `/sales/total`,
});
